<template>
  <!-- Pantalla de "tu plan venció". Sin endpoint de renovación aún: el CTA es un mailto a soporte. -->
  <div class="upgrade-content renewal-content">
    <section class="upgrade-hero" data-surface="immersive">
      <div class="upgrade-hero--inner">
        <span class="upgrade-hero--eyebrow">
          <PhClockCountdown :size="16" weight="regular" />
          {{ $t('renewal.eyebrow') }}
        </span>
        <h1 class="upgrade-hero--title">{{ $t('renewal.title') }}</h1>
        <p class="upgrade-hero--lead">
          {{ $t('renewal.lead', { date: expiredOn, plan: planName }) }}
        </p>
      </div>
    </section>

    <section class="upgrade-closing">
      <div class="card lg elevated bordered upgrade-closing--card">
        <span class="card-icon"><PhEnvelopeSimple :size="32" weight="light" /></span>
        <h2 class="card-title">{{ $t('renewal.closing.title') }}</h2>
        <p class="card-body">{{ $t('renewal.closing.desc') }}</p>
        <div class="upgrade-closing--actions">
          <ds-button variant="primary" :href="mailtoHref">
            {{ $t('renewal.closing.cta') }}
            <template #trailing><PhArrowRight :size="16" weight="regular" /></template>
          </ds-button>
        </div>
        <p class="pl-note">{{ $t('renewal.closing.note') }}</p>
      </div>
    </section>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useSubscription } from '@/composables/useSubscription';
import { useAuth } from '@/composables/useAuth';
import { useHelpers } from '@/composables/useHelpers';
import DsButton from '@/components/ds/DsButton.vue';
import { PhClockCountdown, PhEnvelopeSimple, PhArrowRight } from '@phosphor-icons/vue';
import { SUPPORT_EMAIL } from '@/config/contact';
import { useI18n } from 'vue-i18n';

export default {
  name: 'RenewalContent',
  components: { DsButton, PhClockCountdown, PhEnvelopeSimple, PhArrowRight },
  setup() {
    const { t } = useI18n();
    const { company } = useAuth();
    const { formattedDate } = useHelpers();
    const { subscriptionType, subscriptionCurrentPeriodEnd } = useSubscription();

    const planName = computed(() => subscriptionType.value || '—');
    const expiredOn = computed(() => (
      subscriptionCurrentPeriodEnd.value ? formattedDate(subscriptionCurrentPeriodEnd.value, true) : '—'
    ));

    const mailtoHref = computed(() => {
      const subject = t('renewal.mailto.subject', { company: company.value?.name || '' });
      const body = t('renewal.mailto.body', {
        company: company.value?.name || '',
        plan: planName.value,
        date: expiredOn.value,
      });
      return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    });

    return { planName, expiredOn, mailtoHref };
  },
};
</script>
